module.exports = __webpack_public_path__ + "img/mskv.4d94ea0f.png";